import type { SettingsTabId } from '../../../store/proxy-store';

export const DOCUMENTATION_URL = 'https://app.terra.security/en/docs';
export const SIGN_IN_PATH = '/sign-in';

export const TORCH_SETTINGS_TAB: SettingsTabId = 'general';
export const SHORTCUTS_SETTINGS_TAB: SettingsTabId = 'shortcuts';

export const THEME_CHOICE = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
} as const;

export type ThemeChoice = (typeof THEME_CHOICE)[keyof typeof THEME_CHOICE];
